// Angular Core Modules
import { Component, inject, OnInit } from '@angular/core';
import { AsyncPipe, NgIf } from '@angular/common';

// Third Party Modules
import { Store } from '@ngrx/store';

// Application Modules
import { selectCurrentConsumer } from '@app/resources/ngrx/selectors';
import { ExistingMemberDisplayCardComponent } from '@app/areas/members/components/existing-member-display-card/existing-member-display-card.component';
import { ApplicationProfileService } from '@app/@shared/services/application-profile.service';
import { PortalTheme } from '@app/@shared/models';

@Component({
  selector: 'app-existing-member',
  standalone: true,
  imports: [ExistingMemberDisplayCardComponent, AsyncPipe, NgIf],
  template: `
    <div *ngIf="member$ | async; let member" class="existing-member-wrapper">
      <app-existing-member-display-card [member]="member" [theme]="theme" class="w-100" />
    </div>
  `,
  styleUrl: './existing-member.component.scss',
})
export class ExistingMemberComponent implements OnInit {
  private readonly store = inject(Store);
  private readonly applicationProfileService = inject(ApplicationProfileService);

  protected theme!: PortalTheme;
  protected member$ = this.store.select(selectCurrentConsumer);

  ngOnInit(): void {
    this.applicationProfileService.applicationProfile$.subscribe((profile) => {
      this.theme = profile.PortalTheme.Theme;
    });
  }
}
